import { Layout } from "../components/layout/Layout";
import { Event, EventListener } from "./Event";

export interface LayoutLoadListener extends EventListener {
    (event: LayoutLoadEvent): void;
}

export class LayoutLoadEvent extends Event {
    constructor(target: Layout) {
        super(target);
    }

    public override get target(): Layout {
        return super.target as Layout;
    }

    public get layout(): Layout {
        return this.target;
    }
}
